export enum StepContentListItemType {
    workExperience = 'workExperience',
    school = 'school',
    certification = 'certification',
}
